import React from 'react';

import { PayRateCard } from './PayRateCard';
import { TExtraRate, TExtraRateOption } from './types';

type PayRatesSectionProps = {
    title: string;
    rates: TExtraRate[];
    isEditing: boolean;
    rateOptions: TExtraRateOption[];
    canEditCode: boolean;
    emptyText: string;
    onUpdateRate: (
        rateId: number,
        updater: (rate: TExtraRate) => TExtraRate,
    ) => void;
    onRemoveRate?: (rateId: number) => void;
};

export const TimesheetPayRates: React.FC<PayRatesSectionProps> = ({
    title,
    rates,
    isEditing,
    rateOptions,
    canEditCode,
    emptyText,
    onUpdateRate,
    onRemoveRate,
}) => (
    <div className="timesheet-rates">
        <div className="timesheet-rates__header">
            <h3>{title}</h3>
        </div>
        {rates.length === 0 ? (
            <div className="timesheet-rejections__item">{emptyText}</div>
        ) : (
            <div className="timesheet-booking-cards">
                {rates.map(rate => (
                    <PayRateCard
                        key={`${title}-${rate.id}`}
                        id={rate.id}
                        headerPills={[
                            { label: 'Rate Code', value: rate.extraRateCode },
                        ]}
                        values={{
                            duration: rate.duration,
                            payRate: rate.freelancerPayPerHour,
                            chargeRate: rate.clientPayPerHour,
                            code: rate.extraRateCode,
                            description: rate.description,
                        }}
                        isEditing={isEditing}
                        canEditCode={canEditCode}
                        rateOptions={rateOptions}
                        onDurationChange={(id, value) =>
                            onUpdateRate(id, current => ({
                                ...current,
                                duration: Number(value) || 0,
                            }))
                        }
                        onPayChange={(id, value) =>
                            onUpdateRate(id, current => ({
                                ...current,
                                freelancerPayPerHour: Number(value) || 0,
                            }))
                        }
                        onChargeChange={(id, value) =>
                            onUpdateRate(id, current => ({
                                ...current,
                                clientPayPerHour: Number(value) || 0,
                            }))
                        }
                        onCodeChange={(id, value, name) =>
                            onUpdateRate(id, current => ({
                                ...current,
                                extraRateCode: value,
                                description: name || current.description,
                            }))
                        }
                        onDescriptionChange={(id, value) =>
                            onUpdateRate(id, current => ({
                                ...current,
                                description: value,
                            }))
                        }
                        onRemove={
                            onRemoveRate && isEditing
                                ? () => onRemoveRate(rate.id)
                                : undefined
                        }
                    />
                ))}
            </div>
        )}
    </div>
);

TimesheetPayRates.displayName = 'TimesheetPayRates';
